import { render, staticRenderFns } from "./FormMainStreamRecordStreamax.vue?vue&type=template&id=2c2454c1&scoped=true&"
import script from "./FormMainStreamRecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormMainStreamRecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormMainStreamRecordStreamax.vue?vue&type=style&index=0&id=2c2454c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2454c1",
  null
  
)

export default component.exports